import { AfterViewInit, Component, Input, OnDestroy, ViewChild, inject } from "@angular/core";
import { NavigationEnd, Router, RouterLinkActive } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

interface Badge {
  value?: string | number;
  severity?: 'success' | 'info' | 'warning' | 'danger';
}

@Component({
    selector: "ig-tab",
    templateUrl: "./tab.component.html",
    styleUrls: ["./tab.component.scss"],
    standalone: false
})
export class TabComponent implements AfterViewInit, OnDestroy {
  @Input() tabTitle?: string;
  @Input() tabIcon?: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template?: any;
  @Input() dataContext?: any;
  @Input() tabRouterLink?: string[] | string;
  @Input() disabled = false;
  @Input() tabTooltip?: string;

  /**
   * add a text or counter badge with `{value: string | number, severity?: 'success' | 'info' | 'warning' | 'danger'}`
   */
  @Input() badge?: Badge;

  @ViewChild('rla') rla?: RouterLinkActive;

  readonly #router = inject(Router);
  private destroyed$ = new Subject<void>();

  ngAfterViewInit() {

    setTimeout(()=>{
      if (this.tabRouterLink) {
        this.active = !!this.rla?.isActive;
      }
    })

    this.#router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroyed$)
    ).subscribe(()=> {
      setTimeout(()=>{
        if (this.tabRouterLink) {
          this.active = !!this.rla?.isActive;
        }
      })
    })
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get badgeValue() {
    return String(this.badge?.value || '')
  }
}


